export type CalendarViewMode = "month" | "week";

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

const addDays = (date: Date, days: number) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);

  return next;
};

/** Ponedjeljak tjedna u kojem je zadani datum — tjedan u aplikaciji počinje ponedjeljkom. */
export const startOfWeek = (date: Date) => {
  const day = date.getDay();

  return addDays(startOfDay(date), day === 0 ? -6 : 1 - day);
};

/** Sedam dana tjedna, od ponedjeljka do nedjelje. */
export const buildWeekDays = (date: Date): Date[] => {
  const monday = startOfWeek(date);

  return Array.from({ length: 7 }, (_, index) => addDays(monday, index));
};

/**
 * Mreža mjeseca kao popis punih tjedana.
 *
 * Rubni dani susjednih mjeseci ostaju u mreži (prigušeno se prikazuju) — tako svaki redak
 * ima sedam ćelija i mreža nema rupa, za razliku od prijašnjeg prikaza s praznim mjestima.
 */
export const buildMonthWeeks = (date: Date): Date[][] => {
  const firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  const weeks: Date[][] = [];
  let cursor = startOfWeek(firstOfMonth);

  while (cursor <= lastOfMonth) {
    weeks.push(Array.from({ length: 7 }, (_, index) => addDays(cursor, index)));
    cursor = addDays(cursor, 7);
  }

  return weeks;
};

/** Raspon koji prikaz stvarno pokriva — po njemu se dohvaćaju podaci. */
export const getVisibleRange = (date: Date, view: CalendarViewMode) => {
  const days = view === "week" ? buildWeekDays(date) : buildMonthWeeks(date).flat();

  return { from: days[0], to: days[days.length - 1] };
};
